export { GoalProgressBarChartComponent } from './goal-progress-bar-chart/goal-progress-bar-chart.component';